import { JSX, useMemo } from "react";

import { Grid, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useLocationsDataQuery } from "src/api/locationQueries.api";
import IntervalTabsWrapper from "src/components/IntervalTabs/IntervalTabsWrapper";
import Footfall from "src/components/RegionDashboard/Footfall/Footfall";
import FootfallPinnedLocations from "src/components/RegionDashboard/FootfallPinnedLocations/FootfallPinnedLocations";
import FootfallLastHourComponent from "src/components/RegionDashboard/LiveSection/FootfallLastHourComponent";
import OccupancyLastHourComponent from "src/components/RegionDashboard/LiveSection/OccupancyLastHourComponent";
import PinnedComponent from "src/components/RegionDashboard/Pinned/PinnedComponent";
import SectionTitleWrapper from "src/components/SectionWrapper/SectionWrapper";
import ComponentId from "src/constants/componentId.enum";
import LocationType from "src/types/LocationType";

const componentId = ComponentId.IntervalTabsWithDatepicker;

const styles = {
  fullWidth: { xs: 12 },
  sectionMd4: { xs: 12, md: 4 },
  sectionMd6: { xs: 12, md: 6 },
};

function CenterRegionDashboard(): JSX.Element {
  const { t } = useTranslation();
  const { locationId } = useParams();
  const { data: locations, isLoading } = useLocationsDataQuery();

  const selectedLocation = useMemo(() => locations?.value.find((location) => location.Id === locationId), [locationId, locations]);

  return (
    <>
      {!isLoading && !selectedLocation && (
        <Grid size={styles.sectionMd4}>
          <Alert severity='warning'>{t("No selected Location")}</Alert>
        </Grid>
      )}

      {selectedLocation && (
        <>
          <Grid size={styles.fullWidth}>
            <PinnedComponent displayedType={LocationType.Mall} />
          </Grid>
          <IntervalTabsWrapper componentId={componentId} title={"Historic"}>
            <Grid container spacing={2}>
              <Grid size={styles.fullWidth}>
                <Footfall selectedLocation={selectedLocation} displayedType={LocationType.Mall} componentId={componentId} />
              </Grid>
              <Grid size={styles.fullWidth}>
                <FootfallPinnedLocations selectedLocation={selectedLocation} displayedType={LocationType.Mall} componentId={componentId} />
              </Grid>
            </Grid>
          </IntervalTabsWrapper>
          <SectionTitleWrapper title={"Details"}>
            <Grid container spacing={2}>
              <Grid size={styles.sectionMd6}>
                <FootfallLastHourComponent selectedLocation={selectedLocation} displayedType={LocationType.Mall} />
              </Grid>
              <Grid size={styles.sectionMd6}>
                <OccupancyLastHourComponent selectedLocation={selectedLocation} displayedType={LocationType.Mall} />
              </Grid>
            </Grid>
          </SectionTitleWrapper>
        </>
      )}
    </>
  );
}

export default CenterRegionDashboard;
